import { Sort } from "@/components/_types/sort";

export const getChannelContent = async (
	kind: string,
	channel: string,
	title?: string,
	genre?: string,
	sortObj?: Sort,
	page?: string,
) => {
	const url = new URL(
		`${process.env.NEXT_PUBLIC_API_URL}/public/${kind}/search`,
	);

	url.searchParams.append("channels", channel);

	if (title) {
		url.searchParams.append("title", title);
	}

	if (genre) {
		url.searchParams.append("genres", genre);
	}

	if (page && /^[1-9]\d*$/.test(String(page))) {
		url.searchParams.append("page", String(Number(page) - 1));
	}

	if (sortObj) {
		url.searchParams.append("sortBy", sortObj?.sortBy);
		url.searchParams.append("direction", sortObj?.direction);
	}
	url.searchParams.append("size", "24");

	const res = await fetch(url.toString(), {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
		cache: "no-store",
	});

	if (!res.ok) throw new Error("Failed to fetch Slides");
	return res.json();
};
